import { mainAPI, handleApiError } from "../api";

import { ApiErrorResponse } from "../types/api/error";
import { LanguagesRequest, LanguageResponse } from "../types/api/lang";

const path = `/localizations/${process.env.REACT_APP_API_VERSION}/languages`;

// Языки - Получить список
export function fetchLanguages(params: LanguagesRequest) {
  return mainAPI
    .get<LanguageResponse[]>(`${path}`, {
      params,
      metadata: { addCountry: false },
    })
    .then(
      (res) => {
        const countHeader = res.headers["count"];
        return Promise.resolve({
          list: res.data,
          totalCount: countHeader,
        });
      },
      (error) => handleApiError(error)
    );
}
